/**多語言配置說明 https://segmentfault.com/a/1190000014229902 */
//日本
export const lang ={
  Please_set_materialtype_in_product_page:"完成品・半製品・付属品の各製品の材質タイプを変更・設定するには、商品ページにアクセスしてください。",
deleteAccount:"ログアウト",
deleteAccountWillDeleteAllData:"アカウントからログアウトするとすべてのデータが削除され、ログインできなくなります。",
backupDatabase:"バックアップデータベース",
restoreDatabase:"データベースを復元する",
materialtype:"材料の種類",
Manufacturing:"製造バージョン",
Professional:"プロフェッショナル版",
Standard:"標準版",
product:"完成品",
halfProduct:"半製品",
components:"アクセサリー",
Parent:"親コンポーネント",
Children:"サブアクセサリー",
Level:"階層",
Timing:"タイミング",
PieceCount:"出来高ぎ",
Wages:"賃金",
InternalProcess:"内部プロセス",
ExternalProcess:"外部プロセス",
ProceName:"プロセス名",
ProceIndex:"執行順序",
ChargeMan:"主要",
BillMethod:"請求方法",
ConsumTime:"労働時間",
Accessories:"アクセサリー",
Assembly:"組み立てる",
materials:"材料",
task:"タスク",
process:"プロセス",
BOM:"BOM",
Production:"生産",
RestorePurchaseOneUse:"購入を復元 (1 ユーザー (以前の購入に限定))",
buy_fail_try_again:"購入するにはもう一度クリックしてください",
Export:"輸出",
Date:"日付",
BankDetail:"銀行詳細",
Seller:"売り手",
Buver:"買い手",
Currency:"通貨",
CompanyName:"会社名",
ProformaInvoice:"見積請求書",
Discount:"割引",
PayStatus:"支払い状況",
ShippingStatus:"配送状況",
FreightType:"輸送の種類",
Shipping:"貨物",
Payment:"支払い",
Moneyname:"通貨名",
Tax:"税金",
Freight:"運賃",
Insurance:"保険",
Bankfee:"銀行手数料",
Qc:"品質認証",
Exchangerate:"為替レート",
Shippingnumber:"出荷番号",
ShipDate:"出荷日",
Arrivedate:"到着日",
Grossweight:"総重量",
CubicWeight:"立方重量",
Totalpackages:"パッケージの総数",
Moneytype:"通貨の種類",
Quotedate:"見積日",
Validitydate:"有効期限",
Paymentterm:"給料の期限切れ",
Priceterm:"価格条件",
DeliveryTerm:"納期",
BankName:"銀行名",
BankAddress:"銀行住所",
SwiftCode:"金融機関コード",
Review:"レビュー",
Signfor:"受領書に署名する",
Finance:"ファイナンス",
Receiver:"受信機",
Business:"仕事",
ContactPerson:"連絡担当者",
Profit:"利益",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"従業員はGoogle Chromeを使用する必要があり、メインサービスコンピュータAPPのヘルプページでIPアドレスを確認し、他のコンピュータブラウザのURL欄にアドレスを入力してログインしてください。",
newPassword:"新しいパスワード",
ForgetPassword:"パスワードを忘れる",
ContactUs:"お問い合わせ/ご提案",
Actualpay_should_big_then_shouldpay:"実際の受取額が売掛金を超えることはできません",
ShopAddress:"私の店舗の住所 QRコードをスキャンして注文してください",
Submit:"提出する",
All:"全て",
OrdernumExists:"注文番号はすでに存在します",
PermissionDenied:"許可が拒否されました",
StockTransfer:"株式譲渡",
FromWarehouse:"倉庫からの移動",
ToWarehouse:"倉庫への移動",
PleaseUseInWebBrowser:"Google ChromeのExcelエクスポート機能をご利用ください。",
PleasePrintInWebBrowser:"Google Chromeの印刷機能をご利用ください",
HistoryPrice:"歴史的な価格",
SerialNumber:"シリアルナンバー",
Please_Use_In_APP:"パソコンソフト内でご使用ください",
Please_Purchase_In_APP:"ブラウザ内ではなくアプリ内でご購入ください",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Postgresql データベースに接続できます。データは Postgresql データベースに保存されます。デフォルトでは、Postgresql データベースに接続する必要はありません。デフォルトはローカルの Sqlite データベースです。",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Postgresql データベースに接続すると、データが Postgresql データベースに保存され、データが再度読み取られます。",
Use_sqlite_data_will_store_in_local:"sqlite を使用すると、データはローカル マシンに保存されます。",
UsePostgresqlDatabase:"PGSQLデータベースの使用",
UseSqliteDatabase:"Sqliteデータベースの使用",
DatabaseName:"名前データベース",
Test_connect:"テスト接続",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"カラーやサイズがある商品は、初期在庫に0を記入し、商品追加後、購入時に在庫を入力してください。",
my:"私の",
my_shop_qrcode_scan:"私のストアの QR コードでは、顧客がコードをスキャンして注文できるようになります。顧客の携帯電話は、コンピュータと同じルーターに接続されている必要があります。",
ip:"IP",
port:"ポート",
orderstatus:"注文の状況",
image:"写真",
Template:"テンプレート",
Please_select_a_excel_file:"ファイルを選択してください",
Please_select_only_one_excel_file:"選択できるファイルは 1 つだけです",
Connect_Internet_Login_again:"購入前にインターネットに接続し、再度ログインしてください完成品・半製品・付属品の各製品の材質タイプを変更・設定するには、商品ページにアクセスしてください。",

    productHasValidDate:'商品に有効期間があります',
    productHasColor:'商品はカラーサイズです',
    GeneralGoods:'雑貨',
    Selected:'選択済み',
    RestorePurchase:'購入を再開',
    Buy_ElinkInvoice_Enterprise_Edition_OneUser:'請求書発行Enterprise Edition 1 ユーザーを永久に購入する',
    Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'請求書発行Enterprise Editionはユーザーおよびデバイスに無制限です',
    Purchasing:'購入しています...しばらくお待ちください...',
    Validdate:'有効期間',
    Makedate:'製造日',
    Batch:'バッチ',
    CheckVersion:'バージョン確認',
    Please_set_this_ip_address_on_App:'このIPアドレスまたはAPPのコンピュータのIPアドレスを設定してください。',
    Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'この接続をあなたのコンピューターか携帯のブラウザで開いてください（同じWiFiを接続してください）',


    CheckVersion: 'バージョンの確認',
You_need_to_purchase:'あなたはまだ購入していません、Elink9988 E-mailにWeChatを追加してください：bvbuy@qq.com',
Thank_for_your_purchase: 'あなたはすでに購入しました',
New_version_available:'新しいバージョンがあります',
Is_the_latest_version:'が最新バージョンです',
    please:'お願いします',
input:'入力',
wrong:'違う',
Verifycode:'コードを確認する',
Upload:'アップロードする',
Download:'ダウンロード',
You_need_to_purchase_to_continue_use:'使用を続けるには購入する必要があります',
CheckBuy:'購入を確認',
Exists:'存在する',
NetworkUnavailable:'利用できないネットワーク',
Today:'今日',
Yesterday:'昨日',
ThisMonth:'今月',
LastMonth:'先月',
nickname:'ニックネーム',
storeName:'店舗名',
BuyStandAlone:'スタンドアロン版を購入する',
PermissionDenied:'アクセス拒否',
Boss:'Boss',
    login:'ログイン',
operate:'操作する',
register:'登録',
username:'ユーザー名',
password:'パスワード',
User:'ユーザー',
ok:'OK',
back:'バック',
success:'成功',
fail:'失敗します',
cancel:'キャンセル',
add:'追加する',
edit:'編集する',
delete:'削除する',
refresh:'更新する',
close:'閉じる',
cancel:'キャンセル',
return:'戻る',
ElinkInvoice:'エリンク請求書',
Purchase:'購入',
BaseData:'BaseData',
Sell:'売る',
PurchaseReturns:'購入返品',
SellReturns:'返品を売る',
Inventory:'在庫',
Statistics:'統計',
Receivable:'売掛金',
Payable:'買掛金',
Orders:'ご注文',
StockTransfer:'在庫転送',
StockRecall:'在庫リコール',
Customer:'顧客',
Supplier:'サプライヤー',
Warehouse:'倉庫',
Color:'色',
Size:'サイズ',
Category:'カテゴリー',
Category2:'カテゴリー2',
Product:'製品',
Account:'アカウント',
AccountType:'アカウントカテゴリ',
Staff:'スタッフ',
typeone:'カテゴリー',
typetwo:'サブカテゴリ',
ProductName:'商品名',
Specification:'仕様',
Barcode:'バーコード',
Buyprice:'購入価格',
Sellprice:'販売価格',
Wholesaleprice:'卸売価格',
Currentstock:'電流トック',
Unit:'単位',
Initstock:'初期在庫',
Parameter:'パラメータ',
Remark:'リマーク',
Supplier:'サプライヤー',
Customer:'顧客',
Staff:'スタッフ',
Receivable:'売掛金',
payable:'買掛金',
Receipts:'領収書',
Paid:'有料',
Preferential:'優遇',
DateDay:'日付',
OrderNum:'注文番号',
Name:'名',
UserName:'ユーザー名',
IdNum:'ID番号',
BirthDay:'お誕生日',
SEX:'性別',
Female:'女性',
Male:'男性',
Select:'選択する',
Address:'住所',
Phone:'電話',
Email:'Eメール',
CardNum:'カード番号',
Price:'価格',
QTY:'数量',
SupplierCategory:'サプライヤカテゴリ',
CustomerCategory:'得意先カテゴリ',
Power:'力',
Role:'役割',
save:'保存する',
image:'画像',
search:'サーチ',
Year:'年',
Month:'月',
Day:'日',
Total:'合計',
WorkReport:'作業報告',
Leave:'立ち去る',
CheckIn:'チェックイン',
Announcement:'発表',
Approval:'承認',
Tracking:'追跡',
Bill:'ビル',
OrdersDetail:'注文の詳細',
Expense:'費用',
Income:'所得',
Userfor:'Userfor',
Amount:'量',
Title:'タイトル',
News:'ニュース',
SelectFile:'ファイルを選ぶ',
Content:'コンテンツ',
Cost:'コスト',
ApprovalUser:'承認ユーザー',
ApprovalStatus:'承認状況',
ApprovalRemark:'承認備考',
ApprovalDate:'承認日',
SubmitDate:'提出日',
Status:'状態',
FromDateTime:'日付時刻から',
ToDateTime:'日付時刻へ',
Subject:'件名',
Latitude:'緯度',
Longitude:'経度',
Print:'印刷する',
DataTrans:'データ転送',
OA:'OA',
Setting:'設定',
Help:'助けて',
ScanOpenInPhone:'電話でスキャンオープン',
Building:'建物',
Room:'ルーム',
HotelCheckIn:'チェックイン',
CheckOut:'チェックアウト',
Hotel:'ホテル',
Checkintime:'チェックイン',
Checkouttime:'チェックアウト時間',
Deposit:'預り金',
Cost:'コスト',
RoomNum:'部屋番号',
Rent:'家賃',
costday:'コスデー',
rent:'家賃',
waternum:'水温',
electricnum:'電気学位',
gasnum:'ガス学位',
watercost:'水道代',
electriccost:'電気代',
gascost:'ガス代',
cleaningcost:'クリーニング代',
networkcost:'ネットワークコスト',
tvcost:'テレビ代',
managecost:'コスト管理',
othercost:'その他の費用',
totalcost:'総費用',
remark:'リマーク',
addtime:'addtime',
OpenInBrowser:'ブラウザで開く',
InventoryProfit:'在庫利益',
InventoryLoss:'在庫損失',
Buy:'購入',
Refresh:'更新',
Add:'追加',
Search:'検索',
Records:'件',

    }



// WEBPACK FOOTER //
// ./src/lang/ja.js